import {Show, Text, VStack} from 'platform/foundation';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {getMatchTextColor} from '../utils/getMatchTextColor';

interface RowContactAsideProps {
  phone?: string | null;
  phoneMatchType?: string;
  email?: string | null;
}

export function RowContactAside(props: RowContactAsideProps) {
  if (!isNotNilOrEmpty(props.phone) && !isNotNilOrEmpty(props.email)) {
    return null;
  }

  return (
    <VStack spacing={0} align="flex-end">
      <Show when={isNotNilOrEmpty(props.phone)}>
        <Text size="xSmall" noWrap color={getMatchTextColor(props.phoneMatchType)}>
          {props.phone}
        </Text>
      </Show>
      <Show when={isNotNilOrEmpty(props.email)}>
        <Text size="xSmall" color="secondary" noWrap>
          {props.email}
        </Text>
      </Show>
    </VStack>
  );
}
